import { l as _asyncToGenerator, m as _regeneratorRuntime } from '../_rollupPluginBabelHelpers-2e5b701d.js';
import '../key_codes-a5a2b85e.js';
import { E as ENDPOINTS, I as IMAGE_EXTENSIONS } from '../index-05621ec1.js';

function APIRequest(_x, _x2) {
  return _APIRequest.apply(this, arguments);
}
function _APIRequest() {
  _APIRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, method) {
    var data,
      request,
      response,
      contentType,
      json,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _args.length > 2 && _args[2] !== undefined ? _args[2] : undefined;
          request = new Request(url, {
            method: method || "GET",
            headers: new Headers({
              "Content-Type": "application/json"
            }),
            credentials: "same-origin",
            mode: "cors",
            cache: "default",
            body: JSON.stringify(data)
          });
          _context.prev = 2;
          _context.next = 5;
          return fetch(request);
        case 5:
          response = _context.sent;
          contentType = response.headers.get("content-type");
          if (!(contentType && contentType.indexOf("application/json") !== -1)) {
            _context.next = 12;
            break;
          }
          _context.next = 10;
          return response.json();
        case 10:
          json = _context.sent;
          return _context.abrupt("return", Promise.resolve(json));
        case 12:
          throw new Error("API request failed!");
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 15]]);
  }));
  return _APIRequest.apply(this, arguments);
}
function upload(_x3, _x4, _x5, _x6, _x7) {
  return _upload.apply(this, arguments);
}
function _upload() {
  _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, fileObject, onProgress, onComplete, onError) {
    var url, policy, fd, xhr;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = ENDPOINTS.BASE_URL + ENDPOINTS.POLICY_ENDPOINT;
          _context2.next = 3;
          return APIRequest(url, "POST", fileObject);
        case 3:
          policy = _context2.sent.body;
          fd = new FormData();
          xhr = new XMLHttpRequest();
          Object.keys(policy.fields).map(function (key) {
            fd.append(key, policy.fields[key]);
          });
          fd.append("file", file);

          // Ideally this content type should flow from backend just to avoid edge cases
          // setting a default Content-Type to skip the default(binary/octet-stream) by S3
          if (!fd.get("Content-Type")) {
            fd.set("Content-Type", fileObject.file_object && fileObject.file_object.type || "image/png");
          }
          xhr.upload.onprogress = function (e) {
            if (e.lengthComputable) {
              var percentComplete = (e.loaded / e.total * 100).toFixed(2);
              var percentCompleteToNumber = +percentComplete;
              onProgress(percentCompleteToNumber);
            }
          };
          xhr.onload = function () {
            // Always 204 No Content
            if (xhr.status === 204) {
              var _url = "".concat(policy.url).concat(policy.fields.key);
              var _fileObject$file_obje = fileObject.file_object,
                width = _fileObject$file_obje.width,
                height = _fileObject$file_obje.height;
              if (width && height) {
                _url += "?w=".concat(width, "&h=").concat(height);
              }
              var presignedUrl = policy.presigned_url;
              if (presignedUrl) {
                _url = policy.presigned_url;
              }
              var cdnUrl = _url.replace("haptikappimg.s3.amazonaws.com", "haptikappimg.haptikapi.com");
              onComplete(cdnUrl);
            }
            if (xhr.status === 403 || xhr.status === 400) {
              xhr.onerror();
            }
          };
          xhr.onerror = function (e) {
            if (onError) onError(e);
          };
          xhr.open("POST", policy.url);
          xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
          xhr.setRequestHeader("x-amz-acl", policy.fields && policy.fields.acl);
          xhr.send(fd);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _upload.apply(this, arguments);
}

var uploadFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, onProgress, onComplete, onError, businessId, source) {
    var img, extenstionRegex, extension, fileObject;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          img = new Image();
          extenstionRegex = /(?:\.([^.]+))?$/;
          extension = extenstionRegex.exec(file.name)[1] && extenstionRegex.exec(file.name)[1].toLowerCase();
          fileObject = {
            file_object: {
              type: file.type,
              size: file.size,
              extension: [extension, extension],
              source: source
            }
          };
          if (businessId) {
            fileObject.business_id = businessId;
          }
          if (IMAGE_EXTENSIONS.includes(extension)) {
            img.src = URL.createObjectURL(file);
            img.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    fileObject.file_object.width = img.width;
                    fileObject.file_object.height = img.height;
                    upload(file, fileObject, onProgress, onComplete, onError);
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          } else {
            upload(file, fileObject, onProgress, onComplete, onError);
          }
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function uploadFile(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

export { uploadFile };
